<template>
  <div v-if="authenticatedUser">
    <b-container>
      <!-- Successful Group Join modal -->
      <b-modal @ok="Reload" id="modal-1" ok-only title="Success">
        <p class="my-2">You have successfully joined this group!</p>
      </b-modal>
      <!-- Successful Group Member Acceptance modal -->
      <b-modal id="modal-2" ok-only title="Success">
        <p class="my-2">The applicant has been added to your group!</p>
      </b-modal>

      <b-modal id="modal-3" ok-only title="Success">
        <p class="my-2">The user has successfully become a member of this group!</p>
      </b-modal>

      <b-modal id="modal-4" ok-only title="Success">
        <p class="my-2">The user will become a member once she/he accepts the invitation!</p>
      </b-modal>
      <!--  modal Accept - Reject -->

      <b-modal
        @cancel="RejectCancel"

        @ok="AcceptOk"
        cancel-title="Reject"
        id="modal-9"
        ok-title="Accept"
        ok-variant="danger"
        title="Reply to applicants"
      >
        <p class="my-2">Whose request will you answer to?</p>
        <Autocomplete :EventBus="sendChosenLogin2"></Autocomplete>
      </b-modal>

      <!--  modal Invitation -->
      <b-modal
        @ok="handleInvitationOk"
        id="modal-invite"
        ok-title="Invite"
        ok-variant="danger"
        ref="modal"

        title="Invite someone to this group"
      >
        <p class="my-2">Whom do you wish to invite?</p>

        <!--  <b-form-group
            class="col-12"
            label="For which group will you give your consent?"
            label-align="left"
          >
            <textarea
              v-model="GroupNameConsent"
              class="col-12 form-control"
              rows="1"
              placeholder="Enter Group Name..."
            ></textarea>
            <b-alert
              dismissible
              style="width: 100%"
              v-model="NoGroupAlert"
              variant="danger"
            >You have to specify the right!</b-alert>
          </b-form-group> -->
        <Autocomplete :EventBus="sendChosenLogin2"></Autocomplete>
      </b-modal>
      <!--  modal -->

      <b-modal
        @ok="handleOk"
        id="modal-Join"
        ok-title="Ask to Join"
        ok-variant="danger"

        ref="modal"
      >
        <b-form-group
          class="col-12"
          label="Enter the name of the Group you wish to join?"
          label-align="left"
        >
          <textarea
            class="col-12 form-control"
            placeholder="Enter Group Name..."
            rows="1"
            v-model="GroupName"
          ></textarea>
          <b-alert
            dismissible
            style="width: 100%"
            v-model="NoGroupAlert"
            variant="danger"
          >You have to specify the right!
          </b-alert>
        </b-form-group>
      </b-modal>

      <b-modal
        @ok="handleOk"
        cancel-title="Decline"
        id="modal-ReplyInvitations"
        ok-title="Accept Invitation"
        ok-variant="danger"

        ref="modal"
      >
        <b-form-group
          class="col-12"
          label="Enter the name of the Group you have been invited?"
          label-align="left"
        >
          <textarea
            class="col-12 form-control"
            placeholder="Enter Group Name..."
            rows="1"
            v-model="GroupName"
          ></textarea>
          <b-alert
            dismissible
            style="width: 100%"
            v-model="NoGroupAlert"
            variant="danger"
          >You have to specify the right!
          </b-alert>
        </b-form-group>
      </b-modal>

      <div class="mt-5 mb-3 ml-0 mr-0">
        <b-card no-body>
          <b-card-header header-tag="nav">
            <b-nav card-header fill tabs v-show="selector">
              <b-nav-item @click="showMyGroups" active>Groups I've created</b-nav-item>
              <b-nav-item @click="showPublicGroups">Groups I've joined</b-nav-item>

              <b-nav-item class="text-right text-white" style="NoborderTab">

                <a @click="ReplyToInvitations" class="btn btn-sm bg-orange pb-0 pt-0">Reply to invitations</a>
                <a @click="RequestToJoin" class="btn btn-sm bg-orange pb-0 pt-0">Request to join</a>
                <router-link
                  :to="{name: 'groupAdd'}"
                  class="btn btn-sm bg-orange pb-0 pt-0"
                >Create Group
                </router-link>

              </b-nav-item>
            </b-nav>
            <b-nav card-header fill tabs v-show="!selector">
              <b-nav-item @click="showMyGroups">Groups I've created</b-nav-item>
              <b-nav-item @click="showPublicGroups" active>Groups I've joined</b-nav-item>

              <b-nav-item class="text-right text-white NoborderTab" style="NoborderTab">
                <a @click="ReplyToInvitations" class="btn btn-sm bg-orange pb-0 pt-0">Reply to invitations</a>
                <a @click="RequestToJoin" class="btn btn-sm bg-orange pb-0 pt-0">Request to join</a>
                <router-link
                  :to="{name: 'groupAdd'}"
                  class="btn btn-sm bg-orange pb-0 pt-0"
                >Create Group
                </router-link>

              </b-nav-item>
            </b-nav>
          </b-card-header>

          <b-card-body class="text-center">
            <!-- Own Groups -->

            <GroupSection :type1="ownGroups" id="my-Groups" v-show="selector"/>
            <!-- Public Groups -->
            <GroupSection :type1="publicGroups" id="public-Groups" v-show="!selector"/>
          </b-card-body>
        </b-card>
      </div>
    </b-container>
  </div>
  <div v-else>
    <section class="pb-lg-5 pt-lg-5">
      <b-jumbotron bg-variant="white">
        <template v-slot:header>You do not have access to this page.</template>
        <br/>
        <br/>
        <h3>
          <router-link :to="{name: 'home'}">Home page</router-link>
          |
          <router-link :to="{name: 'login'}">Login</router-link>
        </h3>
      </b-jumbotron>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import GroupSection from '../components/groups/GroupsSection'
import axios from 'axios'
import Autocomplete from './Autocomplete'
import {eventBus} from '../main'

export default {
  name: 'Groups',
  data () {
    return {
      selector: true,
      publicGroups: 'PUBLIC',
      ownGroups: 'OWN',
      GroupName: '',
      GroupNameConsent: '',
      NoGroupAlert: false,
      userID: '',
      userID2: '',
      value1: '',
      value2: '',
      OWNER: '',
      groupToBeInvited: '',
      groupToBeAccepted: '',
      sendChosenLogin2: 'sendChosenLoginforInvitation'
    }
  },
  components: {
    GroupSection, Autocomplete
  },
  computed: {
    ...mapGetters(['authenticatedUser'])
  },
  created () {
    eventBus.$on('sendChosenLoginforConsent', value11 => {
      this.value1 = value11
    })

    eventBus.$on('sendChosenLoginforInvitation', value12 => {
      this.value2 = value12
    })

    axios
      .get('/user', {
        withCredentials: true
      })
      .then(response => {
        this.OWNER = response.data.id
      })

    eventBus.$on('sendgroupIDforAcceptReject', b => {
      this.groupToBeAccepted = b
      this.$bvModal.show('modal-9')
    })

    eventBus.$on('sendgroupIDforConsent', groupId => {
      this.groupToBeInvited = groupId
      this.$bvModal.show('modal-invite')
    })
  },
  methods: {
    Reload () {
      window.location.reload()
    },
    RequestToJoin () {
      this.$bvModal.show('modal-Join')
    },
    ReplyToInvitations () {
      this.$bvModal.show('modal-ReplyInvitations')
    },
    handleOk () {
      axios
        .get('/group/byName?name=' + this.GroupName, {
          withCredentials: true
        })
        .then(response => {
          axios
            .post('/group/memberAcceptGroup/' + response.data.id, null, {
              withCredentials: true
            })
            .then(response => {
              this.$bvModal.show('modal-1')
            })
            .catch(err => {
              this.$bvModal.show('modal-1')
            })
        })
        .catch(err => {

        })
    },
    AcceptOk () {
      axios
        .get('/user/byLogin?login=' + this.value2, {
          withCredentials: true
        })
        .then(response => {
          this.userID2 = response.data.id

          axios.post('/group/groupAcceptMember/' + this.groupToBeAccepted + '?userId=' + this.userID2, null, {
            withCredentials: true
          })
            .then(response => {
              this.$bvModal.show('modal-2')
            })
            .catch(err => {
              this.$bvModal.show('modal-2')
            })
        })
    },
    RejectCancel () {
      axios.post('/group/groupRejectMember/' + this.groupToBeAccepted + '?userId=' + this.userID2, null, {withCredentials: true})
        .then(response => {
        })
    },
    handleInvitationOk () {
      axios
        .get('/user/byLogin?login=' + this.value2, {
          withCredentials: true
        })
        .then(response => {
          this.userID2 = response.data.id

          axios
            .get('/group/' + this.groupToBeInvited, {
              withCredentials: true
            })
            .then(response => {
              var MemberConsent = response.data.needMemberConsent

              axios.post('/group/groupAcceptMember/' + this.groupToBeInvited + '?userId=' + this.userID2, null, {
                withCredentials: true
              })
                .then(response => {
                  if (MemberConsent === true) {
                    this.$bvModal.show('modal-4')
                  } else {
                    this.$bvModal.show('modal-3')
                  }
                })
                .catch(err => {
                  this.$bvModal.show('modal-2')
                })
            })
        })
    },
    showMyGroups () {
      this.selector = true
    },
    showPublicGroups () {
      this.selector = false
    }
  }
}
</script>

<style scoped>

  .NoborderTab {
    border: 0px none;

  }
</style>



// WEBPACK FOOTER //
// src/views/Groups.vue